<template>
  <FeedbackStep :title="title" :number="number">
    <template v-slot:content>
      <div class="feedback-form">
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q4AnswerYes"
            type="radio"
            name="q4Answer"
            value="tak"
            v-model.trim="form.answer_q4"
            @input="delayTouch($v.form.answer_q4)"
            @click="hasDescription = false"
          />
          <label for="q4AnswerYes" class="form__label">tak</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q4AnswerNo"
            type="radio"
            name="q4Answer"
            value="nie"
            v-model.trim="form.answer_q4"
            @input="delayTouch($v.form.answer_q4)"
            @click="hasDescription = false"
          />
          <label for="q4AnswerNo" class="form__label">nie</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q4AnswerOther"
            type="radio"
            name="q4Answer"
            value="inna odpowiedź"
            v-model.trim="form.answer_q4"
            @input="delayTouch($v.form.answer_q4)"
            @change="otherHandler"
          />
          <label for="q4AnswerOther" class="form__label">inna odpowiedź</label>
        </div>
        <transition name="fade-input">
          <div
            v-if="hasDescription"
            class="form__input-wrapper"
            :class="{ error: $v.form.answer_q4_content.$anyError }"
          >
            <label for="answer_q4_content" class="form__label uk-hidden"
              >Podaj inne</label
            >
            <input
              class="form-input uk-width-1-1"
              id="answer_q4_content"
              type="text"
              name="answer_q4_content"
              ref="otherInput"
              @input="event => delayTouchCounterComposition(
                $v.form,
                'answer_q4_content',
                event.target.value
              )"
            />
            <span class="form__error-message form__error-message--no-label">
              <template v-if="!$v.form.answer_q4_content.minLength">
                {{ validationMessage.minLength }}</template
              >
              <template v-if="!$v.form.answer_q4_content.required">
                {{ validationMessage.required }}</template
              >
            </span>
          </div>
        </transition>
      </div>
    </template>
  </FeedbackStep>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';
import FeedbackStep from '../global/FeedbackStep.vue';

export default {
  name: 'Question4',
  components: { FeedbackStep },
  mixins: [stepValidation],
  data: () => ({
    title: 'Czy na początku współpracy planowane działania na rzecz Państwa firmy były przedstawione w sposób zrozumiały?',
    number: 4,
    form: {
      answer_q4: null,
      answer_q4_content: '',
    },
    hasDescription: false,
  }),
  validations() {
    if (!this.hasDescription) {
      return {
        form: {
          answer_q4: {
            required,
          },
        },
      };
    }
    return {
      form: {
        answer_q4: {
          required,
        },
        answer_q4_content: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
  methods: {
    otherHandler() {
      this.hasDescription = true;

      if (!this.hasDescription) {
        this.form.answer_q4_content = '';
      } else {
        setTimeout(() => {
          this.form.answer_q4_content = '';
          this.$refs.otherInput.focus();
        }, 100);
      }
    },
  },
};
</script>
